/**
 * Ticket: SL-698
 * JIRA: https://toolsvilla.atlassian.net/browse/SL-698
 * Description: Common component used to show the table comparision
 * Author: Ankit Nigam
 */
import React from 'react';
/**
 * Price Comparision Table
 * @param {*} param
 * @returns 
 */
const PriceComparisonTable = ({ mProduct, getPriceMatchObject }) => {

  // Extract required values
  const recommendedTransferPrice = mProduct?.recommendedTransferPrice;
  {/*SL-958 Lowest Price */}
  //const otherVendorLowestPrice = mProduct?.lowestPriceMargin ? mProduct.lowestPriceMargin : mProduct.lowestPrice;
  const otherVendorLowestPrice = mProduct.lowestPrice; //SL-1068 fallback condition vendors for restock
  const productPrice = Math.floor(mProduct?.vendor?.[0]?.purchase_price) || Math.floor(mProduct?.vendors?.[0]?.purchase_price) || mProduct?.price;

  // Determine the lowest price
  let recommended = null,isOtherVendorPriceLow = false;
  if (recommendedTransferPrice && otherVendorLowestPrice) {
    if(otherVendorLowestPrice < recommendedTransferPrice){
      recommended = otherVendorLowestPrice;
      isOtherVendorPriceLow = true
    }
    else
      recommended = recommendedTransferPrice;
  } else if (recommendedTransferPrice) {
    recommended = recommendedTransferPrice;
  } else if (otherVendorLowestPrice) {
    recommended = otherVendorLowestPrice;
    isOtherVendorPriceLow = true
  }

  return (
    <table style={{width:"100%"}}>
      <thead></thead>
      <tbody>
        {/* Warning */}
        {recommended && recommended < productPrice ? (
          <tr key="warning">
            <td colSpan="2" className="no-order-table">
              <div className="comp-msg" style={{ marginTop: '5px', fontSize: '10px', color: 'red', fontWeight: '600', padding: '1px 4px', background: '#ffe5e5' }}>
                <img src="/warning-triangle.png" alt="warning" style={{ width: '12px', marginRight: '5px' }} />
                High Price vs competitors
              </div>
            </td>
          </tr>
        ) : null}

        <tr key="all_prices"  style={{ borderSpacing: '0 8px' }} >

         {/* Other Seller Price */}
        {isOtherVendorPriceLow && otherVendorLowestPrice && otherVendorLowestPrice < productPrice ? (
            <td className="no-order-table">
            <span className='price-com-val'>Other : </span>
            <span className='price-com-val'>
              <i className="fa fa-inr" style={{ verticalAlign: 'middle', lineHeight: 'inherit' }} aria-hidden="true"></i>{' '}
              {otherVendorLowestPrice}
            </span>
              </td>
        ) : null}

        {/* Market Price */}
        { !isOtherVendorPriceLow && recommendedTransferPrice && recommendedTransferPrice < productPrice && (!otherVendorLowestPrice || 
          ( otherVendorLowestPrice && recommendedTransferPrice < otherVendorLowestPrice) 
          ) ? (
            <td className="no-order-table">
              <img src="/market.png" alt="fall" style={{ marginLeft: '15px', marginBottom: '3px', verticalAlign: 'middle' }} />
              <span className='price-com-val'> Market Price : </span>
            <span className="price-com-val" style={{ fontSize: '10px', fontWeight: '400' }}>
              <i className="fa fa-inr" style={{ verticalAlign: 'middle', lineHeight: 'inherit' }} aria-hidden="true"></i>{' '}
              {recommendedTransferPrice}
              </span>
            </td>
        ) : null}

        {/* Recommended Price */}
        {recommended && recommended < productPrice ? (
            <td className="no-order-table">
              <img src="/fall.png" alt="fall" style={{ marginBottom: '3px', verticalAlign: 'middle' }} />
              <span className='price-com-val'>Recommended : </span>
            <span className="price-com-val">
              <i className="fa fa-inr" style={{ verticalAlign: 'middle', lineHeight: 'inherit' }} aria-hidden="true"></i>{' '}
              {isOtherVendorPriceLow ? otherVendorLowestPrice : recommended}
            </span>
          </td>
        ) : null}


         </tr>

        {/* Accept Button */}
        {recommended && recommended < productPrice ? (
          <tr key="accept_button">
            <td colSpan="2" className="no-order-table">
              <div
                style={{ textAlign: 'center', display: 'inline-block' }}
                onClick={() =>
                  getPriceMatchObject({
                    otherPrice: 20,
                    SKU: mProduct.SKU,
                    productId: typeof mProduct.lead != 'undefined' ? mProduct.lead : mProduct?._id,
                    lowestPrice: isOtherVendorPriceLow ? otherVendorLowestPrice : recommended,
                  })
                }
                className="pc_rec_accept_button"
              >
                <button>Accept</button>
              </div>
            </td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );
};

export default PriceComparisonTable;